export default __webpack_public_path__ + "static/media/busverbindung-neubauprojekte-wien.60a8b604.svg";